export default __webpack_public_path__ + "static/media/cross-icon-mobile.4e82fff5.svg";